import { type ReactNode, createContext, useContext } from "react";

/** Entity segment on `GET /files/{entityType}/{organizationId}/{entityId}/{fileId}`. */
export type DynamicFormHostEntityType =
	| "jobs"
	| "tickets"
	| "assets"
	| "records";

export interface DynamicFormHost {
	organizationId: string;
	/**
	 * Runtime entity forms upload signatures and look up addresses.
	 * Form-editor preview sets this false.
	 */
	runtime: boolean;
	entityType?: DynamicFormHostEntityType;
	entityId?: string;
}

const DynamicFormHostContext = createContext<DynamicFormHost | null>(null);

export function DynamicFormHostProvider({
	value,
	children,
}: {
	value: DynamicFormHost;
	children: ReactNode;
}) {
	return (
		<DynamicFormHostContext.Provider value={value}>
			{children}
		</DynamicFormHostContext.Provider>
	);
}

export function useDynamicFormHost(): DynamicFormHost | null {
	return useContext(DynamicFormHostContext);
}
